import React from "react";
import './TauriSimpleBreadcrumbs.css';

const TauriSimpleBreadcrumbs = ({ path }) => {
    // Split the path into segments
    const segments = path.split('/');

    return (
        <div className="simple-breadcrumbs">
            {segments.map((segment, index) => (
                <React.Fragment key={index}>
                    <span className="breadcrumb-item">{segment}</span>
                    {index < segments.length - 1 && (
                        <span className="breadcrumb-separator">&#9658;</span>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
}

export default TauriSimpleBreadcrumbs